__turbopack_context__.v({
  "headerRightSection": "Y-5cxa_headerRightSection",
  "infoButton": "Y-5cxa_infoButton" + " " + __turbopack_context__.i(248112)["focusOutline"],
  "numberOfReviewsText": "Y-5cxa_numberOfReviewsText",
  "ratingBadge": "Y-5cxa_ratingBadge",
  "ratingBadgeHero": "Y-5cxa_ratingBadgeHero",
  "ratingLabel": "Y-5cxa_ratingLabel",
  "ratingLabelHero": "Y-5cxa_ratingLabelHero",
  "wrapper": "Y-5cxa_wrapper",
});
